import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: null,
        roles: ['', 'ROLE_GUEST', 'ROLE_USER', 'ROLE_ADMIN'],
        dfLoading: false,
        dfData: [],
        profile: localStorage.getItem('profile') || 'uat'
    },
    mutations: {
        setUser(state, userData) {
            state.user = userData;
        },
        removeUser (state) {
            document.cookie = 'access_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            document.cookie = 'refresh_token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            state.user = null
        },
        setNodeData(state, data) {
            state.dfData = data
        },
        setLoading(state, isLoading) {
            state.dfLoading = isLoading
        },
        setProfile(state, profile) {
            localStorage.setItem('profile', profile)
            state.profile = profile
        },
        setLeaveInformation(state, userInformation) {
            state.user.leaveStatus = userInformation.leaveStatus
            state.user.leave = userInformation.leave
            state.user.actingUsr = userInformation.actingUsr
            state.user.leaveStartDt = userInformation.leaveStartDt
            state.user.leaveEndDt = userInformation.leaveEndDt
            state.user.leaveReason = userInformation.leaveReason

            var user = localStorage.getItem('user');
            // Parse the item if it's in JSON format
            if (user !== null) {
                user = JSON.parse(user);
            }
            // Modify the item
            if (user !== null) {
                user.leaveStatus = userInformation.leaveStatus;
                user.leave = userInformation.leave;
                user.actingUsr = userInformation.actingUsr;
                user.leaveStartDt = userInformation.leaveStartDt;
                user.leaveEndDt = userInformation.leaveEndDt;
                user.leaveReason = userInformation.leaveReason;
            }
            // Convert the item back to a string if it was originally in JSON format
            if (user !== null) {
                user = JSON.stringify(user);
            }
            // Save the modified item back to localStorage
            localStorage.setItem('user', user);
        },
    },
    actions: {
    },
    getters: {
        isLogged: state => !!state.user,
        getUser: state => {
            return state.user
        },
        // 3단계 롤은 백엔드 user.roles(Set: GUEST/USER/ADMIN) 이 SoT.
        isAdmin: state => Array.isArray(state.user?.roles) && state.user.roles.includes('ADMIN'),
        // user 티어 이상(=배포 가능 롤). 실제 배포는 스택별로 추가 판정(admin=전체, user=demo).
        isUser: state => Array.isArray(state.user?.roles) &&
            (state.user.roles.includes('USER') || state.user.roles.includes('ADMIN')),
        isGuest: (state, getters) => !!state.user && !getters.isUser,
        // 배포 허용 스택(=user 의 scopes). admin 은 전체라 무관.
        deployableStacks: state => Array.isArray(state.user?.scopes) ? state.user.scopes : [],
        getRoleNum: state => {
            return (state.roles.indexOf(state.user?.role) || 0)
        },
        getRoles: state => {
            return (state.roles)
        },
        getUserName: state => {
            return state.user?.username
        },
        // getName: state => {
        //     return state.user?.name
        // },
        getLeave: state => {
            return state.user?.leave
        },
        getLeaveStatus: state => {
            return JSON.parse(state.user?.leaveStatus)
        },
        getLeaveStartDt: state => {
            return state.user?.leaveStartDt
        },
        getLeaveEndDt: state => {
            return state.user?.leaveEndDt
        },
        getLeaveReason: state => {
            return state.user?.leaveReason
        },
        getActingUsrId: state => {
            return state.user?.actingUsr
        },
        getProviderId: state => {
            return state.user?.id
        },

        getDfData: (state) => (name) => {
            // return ((type === 2) && state.dfData.gw) || ((type === 3) && state.dfData.core)
            return state.dfData.find(v => v.name === name) || {availableReplicas: 0, replicas: 0, unavailableReplicas: 0, specReplicas:1}
        },
        getDfLoading: state => {
            return state.dfLoading
        },
        getProfile: state => {
            return state.profile
        },
    }
})
